export const TAB_KEYS = {
  Active: "Active",
  Inactive: "Inactive",
};
export const TAB_LISTS = [
  {
    key: TAB_KEYS.Active,
    isActive: function (currentTab) {
      return isTabActive(this.key, currentTab);
    },
    value: "USER_MANAGEMENT.TABS.ALL",
    count: function (tabsCount) {
      return tabsCount?.[this.key] || 0;
    },
  },
  {
    key: TAB_KEYS.Inactive,
    isActive: function (currentTab) {
      return isTabActive(this.key, currentTab);
    },
    value: "USER_MANAGEMENT.TABS.Inactive",
    count: function (tabsCount) {
      return tabsCount?.[this.key] || 0;
    },
  },
];

function isTabActive(tab, currentTab) {
  return tab === currentTab;
}
